import React, { useState, useEffect } from "react";

import { makeStyles } from '@material-ui/core/styles';

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from '@material-ui/core/Button';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import ReviewPicPay from 'views/Checkout/ReviewPicPay';
import LoadingGrid from "components/Loading/LoadingGrid.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';

import api from 'services/api.js';
import {serverApi} from 'services/constante.js';
import { array } from "prop-types";

const useStyles = makeStyles((theme) => ({
    boxPayment: {
        width: '60%',
        margin: '0 auto',
        textAlign: 'center',
        padding: 13,
        backgroundColor: '#f9f7f7',
        borderRadius: 5,
    },
    boxPaymentMobile: {
        width: '100%',
        margin: '0 auto',
        textAlign: 'center',
        padding: 13,
        backgroundColor: '#f9f7f7',
        borderRadius: 5,
    },
    titlePicPay: {
        fontSize: 20,
        fontFamily: 'Montserrat,sans-serif'
    },
    descriptionPicPay: {
        color: '#716d6d',
        paddingTop: 8,
        textAlign: 'center',
        fontFamily: 'Montserrat,sans-serif',
        fontSize: 15
    },
    counterPicPay: {
        fontSize: 10,
        fontFamily: 'Montserrat,sans-serif',
        color: '#716d6d',
        textAlign: 'center',
        marginBottom: 0
    },
    boxQrCode: {
        width: '80%',
        margin: '0 auto',
        border: 'rgba(231,242,251,.45)',
        borderStyle: 'groove'
    },
    qrCode: {
        width: '100%'
    },
    infoCodeOrder: {
        fontSize: 10,
        fontFamily: 'Montserrat,sans-serif',
        color: '#716d6d',
        textAlign: 'center',
    },
    infoCodeOrderSpan: {
        fontWeight: 600
    },
    linkPicPay: {
        color: '#21c25e',
        fontFamily: 'Montserrat,sans-serif',
        textAlign: 'center',
        fontWeight: 800,
    },
    linkPagamento: {
        color: '#716d6d',
        fontFamily: 'Montserrat,sans-serif',
        fontSize: 10,
    },
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
        width: 600,
        marginLeft: 'auto',
        marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: theme.spacing(3, 0, 5),
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    logo: {
        textAlign: 'center'
    }
}));

export default function PicPay(props) {
    const classes = useStyles();
    const [items, setItems] = useState([]);
    const [payment, setPayment] = useState(false);
    const [contador, setContador] = useState(0);
    const [paymentCode, setPaymentCode] = useState("");
    const [paymentLink, setPaymentLink] = useState("");
    const [paymentQrCode, setPaymentQrCode] = useState("");
    const [loadingGrid, setLoadingGrid] = useState(false);
    const [displayNone, setDisplayNone] = useState(false);
    const [pe, setPE] = useState([]);// Produtos Extras
    const [guidsPE, setGuidsPE] = useState([]);// Guids Produtos Extras
    const [pesSolo, setPesSolo] = useState([]);// Produtos Extras SEPARADOS

    const matches = useMediaQuery('(max-width:600px)');

    var timer =  null;

    useEffect(() => {          
        carregarDados();
    },[props] );

    async function carregarDados() {
        //setLoadingGrid(true);
        
        let prodExtras = [];
        let id_plano = props.match.params.idplano;
        let id_plano_detalhe = props.match.params.idplanodetalhe;
        
        if (id_plano != undefined && id_plano_detalhe != undefined) {
            var formdata = new FormData();
            formdata.append('function', 'get_plano_by_id_plano_id_plano_detalhe');
            formdata.append('id_plano', id_plano);
            formdata.append('id_plano_detalhe', id_plano_detalhe);

            await api.post(serverApi.urlPHP + '/plano.php', formdata)
            .then(function (response) {
                //console.log(response);
                let plano = response.data.plano;
                setItems([{Descricao: plano.Descricao, Periodicidade: plano.Periodicidade, Preco: plano.Preco}]);

                //GOOGLE ANALYTICS
                window.gtag('event', 'select_content', {
                    "content_type": "product",
                    "items": [
                    {
                        "id": id_plano + "_" + id_plano_detalhe,
                        "name": plano.Descricao + " Periodicidade: " + plano.Periodicidade,
                        "brand": "Flow Multas",
                        "category": "Plano",
                        "quantity": 1,
                        "price": parseFloat(plano.Preco)
                    }
                ]});
            })
            .catch(function (error) {
                console.log(error);
            })
            .finally(() => {   
                //setLoadingGrid(false);
                produtosExtras();
            });
        } else {
            let guids = "";
            let quant = "";
            if(props.location.state != undefined) {
                guids = props.location.state.guidspesolo;
                quant = props.location.state.guidsquantity;
            }

            for (var [key, value] of guids) {
                let guidAtual = key;
                const quantAtual = quant.get(guidAtual);
                //let prodExtras = [];
                await api.get(serverApi.url + `${serverApi.versao}/ProdutoExtra/Resumo/${guidAtual}`)
                .then(function (response) {
                    let produto = response.data;
                    prodExtras.push({Guid: produto.Guid, Nome: produto.NomeProduto, Descricao: produto.DescricaoProduto, Preco: produto.ValorProduto, Quantidade: quantAtual});
                    //ABASTECER ARRAY DE GUIDS
                    handleChangeGuidsPE(produto.Guid);
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {   
                    setLoadingGrid(false);
                });
                
            }
            setPesSolo(prodExtras);
        }
        produtosExtras(prodExtras);
    }

    async function produtosExtras(prodExtras) {
        await api.get(serverApi.url + '/api/appUsuario/v1/ProdutoExtra/Todos')
        .then(function (response) {
            let listaExtrasBd = response.data;
            let listaExtrasIguaisTemp = [];
            for (let index = 0; index < listaExtrasBd.length; index++) {
                const element = listaExtrasBd[index];
                for (let i = 0; i < prodExtras.length; i++) {
                    const element2 = prodExtras[i];
                    if(element.Guid == element2.Guid) {
                        listaExtrasIguaisTemp.push(element);
                    } 
                }
            }
            for (let index = 0; index < listaExtrasIguaisTemp.length; index++) {
                const element = listaExtrasIguaisTemp[index];
                listaExtrasBd.splice(listaExtrasBd.indexOf(element), 1);
            }
            setPE(listaExtrasBd);
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(() => {   
            //setLoadingGrid(false);
        });
    }

    async function handlePayment () {
        setLoadingGrid(true);
        let email_user = localStorage.getItem("CLLogin");
        let id_plano = props.match.params.idplano;
        let id_plano_detalhe = props.match.params.idplanodetalhe;
        let guids_produtos_extras = guidsPE;
        
        var formdata = new FormData();
        formdata.append('email', email_user);
        //VERIFICA SE TEM PLANO ENVOLVIDO NA COMPRA
        if (id_plano != undefined && id_plano_detalhe != undefined) {
            formdata.append('plano', id_plano);
            formdata.append('plano_detalhe', id_plano_detalhe);
        }
        formdata.append('guids_produtos_extras', guids_produtos_extras);
        formdata.append('payment_method', "PICPAY");
        
        await api.post(serverApi.urlPHP + '/ecommerce/gerapedido.php', formdata)
        .then(function (response) {
            //console.log(response);
            startTimer();
            let responseServer = response.data;
            if(responseServer.response == "success") {
                setPayment(true);
                setPaymentCode(responseServer.referenceId);
                setPaymentLink(responseServer.paymentUrl);
                setPaymentQrCode(responseServer.qrCode);
                
                //GOOGLE ANALYTICS
                let itemsGA = [];
                if (id_plano != undefined && id_plano_detalhe != undefined) {
                    items.map(function(plano) {
                        itemsGA.push({
                            "id": responseServer.referenceId + Math.floor(Math.random() * 99999),
                            "name": plano.Descricao + " Periodicidade: " + plano.Periodicidade,
                            "brand": "Flow Multas",
                            "category": "Plano",
                            "list_position": 1,
                            "quantity": 1,
                            "price": parseFloat(plano.Preco)
                        });
                    });
                }
                window.gtag('event', 'purchase', {
                    "transaction_id": responseServer.referenceId,
                    "value": 2.50,
                    "currency": "BRL",
                    "tax": 0.00,
                    "shipping": 0,
                    "items": itemsGA
                });
            }
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(() => {   
            setLoadingGrid(false);
        });
    }

    function startTimer() {
        let tempo = new Number();
        // Tempo em segundos -> tempo de validade do qrCode do PicPay
        tempo = 600;

        if (timer != null) {
            clearInterval(timer);
            timer = null;
        } else {
            timer = setInterval(() => {
                let horaImprimivel ="";
        
                // Se o tempo não for zerado
                if((tempo - 1) >= 0) {

                    // Pega a parte inteira dos minutos
                    var min = parseInt(tempo/60);
                    // Calcula os segundos restantes
                    var seg = tempo%60;

                    // Formata o número menor que dez, ex: 08, 07, ...
                    if(min < 10){
                        min = "0"+min;
                        min = min.substr(0, 2);
                    }
                    if(seg <=9){
                        seg = "0"+seg;
                    }

                    // Cria a variável para formatar no estilo hora/cronômetro
                    horaImprimivel = '00:' + min + ':' + seg;
                    setContador(horaImprimivel);

                    // diminui o tempo
                    tempo--;
                } else {
                    setContador("00:00:00");
                    setDisplayNone(true);
                }
                
            }, 1000);
        }
    }

    function handleChangeGuidsPE(guid) {
        let listaGuids = guidsPE;
        if(listaGuids.indexOf(guid) < 0) {
            listaGuids.push(guid);
        } else {
            listaGuids.splice(listaGuids.indexOf(guid), 1);
        }
        setGuidsPE(listaGuids);
    }

    return (
        <>
            <LoadingGrid display={loadingGrid} />
            <div style={{display: (!loadingGrid ? '' : 'none')}}>
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Typography component="h1" variant="h4" align="center">
                            Checkout
                        </Typography>
                        <Stepper activeStep={1} className={classes.stepper}>
                            <Step>
                                {payment ? ( 
                                    <StepLabel>{"Pagamento"}</StepLabel>
                                ) : (
                                    <StepLabel>{"Resumo do pedido"}</StepLabel>
                                )}
                            </Step>
                        </Stepper>
                        <React.Fragment>
                            {payment ? (
                                <React.Fragment>
                                    <div className={classes.logo}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="250" viewBox="0 0 129 44"><path fill="#21c25e" d="M28 34.3h5.8V17.4H28V34.3zM35.8 5.9h-3.9v3.9h3.9V5.9zM13.9 7.8H8.3v4.9h5.2c3.3 0 5.2 1.6 5.2 4.6 0 3-1.9 4.7-5.2 4.7H8.3v-9.2H2.5v21.5h5.8v-7.4h5.5c6.7 0 10.6-3.6 10.6-9.8C24.4 11.3 20.6 7.8 13.9 7.8zM39.7 2H28v11.7h11.7V2zM37.8 11.7H30V3.9h7.8V11.7zM71.8 7.8h-5.3v4.9h5c3.3 0 5.2 1.6 5.2 4.6 0 3-1.9 4.7-5.2 4.7h-5v-9.2h-5.8v21.5h5.8v-7.4h5.3c6.7 0 10.6-3.6 10.6-9.8C82.4 11.3 78.5 7.8 71.8 7.8zM120.5 14l-5 12.6 -5-12.6h-6l8 20.3 -3.1 7.7h6.1l11-28H120.5zM94.5 13.9c-3.5 0-6.2 0.8-9.2 2.3l1.8 4c2.1-1.2 4.2-1.8 6.1-1.8 2.8 0 4.2 1.2 4.2 3.4v0.4h-5.6c-5 0-7.7 2.3-7.7 6.1 0 3.7 2.6 6.3 7 6.3 2.8 0 4.8-1 6.4-2.7v2.2h5.7l0-13.2C103 16.6 99.9 13.9 94.5 13.9zM97.9 27.5c-0.6 1.7-2.3 3.1-4.7 3.1 -2 0-3.2-1-3.2-2.6 0-1.6 1.1-2.3 3.3-2.3h4.6V27.5zM48.6 29.9c-2.8 0-4.8-2.2-4.8-5.5 0-3.2 2-5.4 4.8-5.4 2 0 3.5 0.8 4.6 2.2l3.9-2.8c-1.8-2.7-4.9-4.3-8.8-4.3C42.2 14 38 18.2 38 24.4c0 6.2 4.2 10.3 10.3 10.3 4.2 0 7.3-1.7 9-4.5l-4-2.7C52.3 29.1 50.7 29.9 48.6 29.9z"></path></svg>
                                    </div>
                                    <div className={matches ? classes.boxPaymentMobile : classes.boxPayment}>
                                        <Typography variant="h4" classes={{ root: classes.titlePicPay }} align="center" gutterBottom>
                                            <b>Pague com PicPay</b>
                                        </Typography>
                                        <p className={classes.descriptionPicPay}>Abra o PicPay em seu telefone e escaneie o código abaixo:</p>
                                        <p className={classes.counterPicPay}>Este código expira em: {contador}</p>
                                        <div className={classes.boxQrCode}>
                                            <img className={classes.qrCode} style={{display: (displayNone ? 'none' : '')}} src={paymentQrCode} />
                                            <div style={{display: (!displayNone ? 'none' : '')}}>
                                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon" viewBox="0 0 94 94" width="210">
                                                    <g fill="none" fill-rule="evenodd" stroke="#ED1846" stroke-width="3" transform="translate(2 2)">
                                                        <circle cx="45" cy="45" r="45"></circle>
                                                        <path d="M26.823 63.346L63.185 27 26.823 63.346zM26.823 27l36.346 36.362L26.823 27z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                        <a href={paymentLink} style={{display: (displayNone ? 'none' : '')}} className={classes.linkPagamento}>Se preferir clique aqui para efetuar o pagameto</a>
                                        <p className={classes.infoCodeOrder}>Código do seu pedido: <span className={classes.infoCodeOrderSpan}>{paymentCode}</span></p>
                                        <a href="https://blog.picpay.com/apresentamos-o-seu-c%C3%B3digo-pessoal-receber-pagamentos-ficou-ainda-mais-f%C3%A1cil-7e0a5910fe3b" target="_blank" className={classes.linkPicPay}>Como faço para escanear?</a>
                                    </div>
                                </React.Fragment>
                            ) : (
                                <React.Fragment>
                                    <ReviewPicPay items={items} pes={pe} pesSolo={pesSolo} handleChangeGuidsPE={handleChangeGuidsPE} />
                                    <div className={classes.buttons}>
                                        <Button variant="contained" onClick={handlePayment} color="primary" className={classes.button}>
                                            Pagar
                                        </Button>
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    </Paper>
                </main>
            </div>
        </>
    );
}